import styles from "./PackageBoxIcon.module.scss"

type Props = {
    // open = a draft being packed (lid flaps up); sealed = dispatched (taped shut).
    variant: "open" | "sealed"
    size?: number
    className?: string
    // Plays the tilt-and-settle wobble (the "something just landed in the box"
    // reaction). Re-triggered by remounting with a changing key.
    wobble?: boolean
    style?: React.CSSProperties
}

/**
 * The Work Package mark: an isometric outline box, the one glyph the package
 * concept wears everywhere (tray pill, Drafts|Sent toggle, package header,
 * empty states). Two states tell the lifecycle at a glance — open while you're
 * packing, sealed once it ships. Stroke-only so it sits naturally beside
 * PrimeIcons at any size from 14px up.
 */
const PackageBoxIcon = ({ variant, size = 20, className, wobble = false, style }: Props) => (
    <svg
        width={size}
        height={size}
        viewBox="0 0 24 24"
        fill="none"
        stroke="currentColor"
        strokeWidth="1.7"
        strokeLinecap="round"
        strokeLinejoin="round"
        className={`${styles.box} ${wobble ? styles.wobble : ""} ${className ?? ""}`}
        style={style}
        aria-hidden="true"
    >
        {variant === "sealed" ? (
            <>
                {/* Closed cube: hexagon silhouette + inner Y edges + tape seam */}
                <path d="M12 3l9 5v8l-9 5-9-5V8z" />
                <path d="M3 8l9 5 9-5" />
                <path d="M12 13v8" />
                <path d="M12 3v10" opacity="0.55" />
            </>
        ) : (
            <>
                {/* Open carton: the FULL cube (same 3D silhouette as sealed —
                    the top rhombus is the rim of the mouth) with the two side
                    lids drawn as open PANELS — parallelograms hinged on the
                    back rim edges, folded up-and-out. Open vs sealed differ by
                    open lids vs tape, never by losing the third dimension. */}
                <path d="M12 3l9 5v8l-9 5-9-5V8z" />
                <path d="M3 8l9 5 9-5" />
                <path d="M12 13v8" />
                <path d="M3 8L1.2 5.2l9-5L12 3" />
                <path d="M21 8l1.8-2.8-9-5L12 3" />
            </>
        )}
    </svg>
)

export default PackageBoxIcon
